import React from "react";
import { Badge, Box, Divider, SimpleGrid, Text } from "@chakra-ui/react";
import JSONPretty from "react-json-pretty";
import { useSelector } from "react-redux";
import _ from "lodash";
import {
  formatDelay,
  formatTimestamp,
  getDelayValue,
  getDeliveryState,
  getMessageTimeline,
  getProviderName,
  getProviderStatusLabel,
} from "./../utils/smsDelays";

const MessageCard = ({ id }) => {
  const { messages } = useSelector((state) => state.defaultReducer);

  const messagesClone = _.cloneDeep(messages);
  const messageData = messagesClone.find((a) => a.id === id);
  if (!messageData) return null;

  const timeline = getMessageTimeline(messageData);
  const deliveryState = getDeliveryState(messageData);
  const timingRows = [
    { label: "Received", value: formatTimestamp(timeline.received) },
    { label: "Sent", value: formatTimestamp(timeline.sent || messageData.created) },
    { label: "Delivered", value: formatTimestamp(timeline.delivered) },
    { label: "Provider", value: getProviderName(messageData) },
    { label: "Provider Status", value: getProviderStatusLabel(messageData) },
    { label: "Provider Message ID", value: messageData.providerMessageId || "N/A" },
    { label: "Provider Updated", value: formatTimestamp(timeline.providerUpdated) },
    {
      label: "Queue Delay",
      value: formatDelay(getDelayValue(messageData, "queueDelaySeconds")),
    },
    {
      label: "Delivery Delay",
      value: formatDelay(getDelayValue(messageData, "deliveryDelaySeconds")),
    },
    {
      label: "Total Delay",
      value: formatDelay(getDelayValue(messageData, "totalDelaySeconds")),
    },
  ];

  return (
    <Box>
      <Badge colorScheme={deliveryState.colorScheme} mb={3}>
        {deliveryState.label}
      </Badge>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3} mb={4}>
        {timingRows.map((row) => (
          <Box key={row.label}>
            <Text fontSize="12px" color="var(--gray-8)" mb={0}>
              {row.label}
            </Text>
            <Text fontSize="14px" fontWeight="600" color="var(--black-dry)">
              {row.value}
            </Text>
          </Box>
        ))}
      </SimpleGrid>

      <Divider mb={4} />
      <JSONPretty data={messageData} />
    </Box>
  );
};

export default MessageCard;
